import React, { Component, useEffect, useState } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import Select from 'react-select'
import copyright from '../../img/copyright-gray.png';
import useEmpresa from '../Hooks/useEmpresa';
import useProgramacion from '../Hooks/useProgramacion';
import ReactExport from "react-data-export";
import { Pulse } from 'react-preloading-component';
import ModalObervacion from './Components/ModalObservacion';

const ReporteOperacionalA = (props) => {

  const [fecha1, setFecha1] = useState('');
  const [fecha2, setFecha2] = useState('');
  const [empresa, setEmpresa] = useState('');
  const [viaje, setViaje] = useState('');
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
  const empresas = useEmpresa();
  const filtro = [{ label: "Todos los viajes", value: '' }, { label: "Viajes Finalizados", value: 'Finalizado' }, { label: "Viajes Cancelados", value: 'Cancelado' }, { label: "Viajes Pendientes", value: 'Pendiente' }]
  const programacion = useProgramacion(fecha1, fecha2, empresa, viaje);
  const [isModalActive, setIsModalActive] = useState(false);
  const [programacionData, setProgramacionData] = useState(programacion.data);
  const [indiceActual, setIndiceActual] = useState();
  const [dataModal, setDataModal] = useState({});

	const modalObser = (row, ...rest) => {
		setIndiceActual(rest[1]);
		setDataModal(row);
		setIsModalActive(true);
	}

const transform = (item)=> {
	if(item.comentarioAdmin && item.comentario!=='---')
		item.comentarioFinal = `Conductor: ${item.comentario}. Administrador: ${item.comentarioAdmin}`
		
	else 
	item.comentarioFinal = item.comentarioAdmin ? `Administrador: ${item.comentarioAdmin}` : item.comentario;

	return item;
}


const updateComment = (comentarioAdmin)=>{
	setProgramacionData(prevProgramacionData => {
		prevProgramacionData[indiceActual].comentarioAdmin=comentarioAdmin;

		return prevProgramacionData.map(transform);
	});
}

useEffect(() => {
	const data = programacion.data.map(transform);
	setProgramacionData(data);
}, [programacion.data])

  let name = 'Reporte Operacional';

  return (
    <div className="Rrporte container">
	{
      isModalActive&&
      <ModalObervacion 
		data={dataModal}
		update={updateComment}
		close={()=>setIsModalActive(false)} 
      />
    }
      <div className="container">
        <div className="row header-margin-top">
          <div className="col-md-11">
            <h3 className="title-blue">Reporte Operacional</h3>
            <span className="text-info">Visualización de Reportes</span>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 col-xs-6">
            <div className="form-group">
              <label htmlFor=" fecha1">Fecha Inicio</label>
              <input type="date" name="fecha1" className="form-control"
                onChange={e => { setFecha1(e.target.value) }}
              />
            </div>
          </div>
          <div className="col-md-3 col-xs-6">
            <div className="form-group">
              <label htmlFor="fecha2">Fecha Final</label>
              <input type="date" name="fecha2" className="form-control"
                onChange={e => { setFecha2(e.target.value) }}
              />
            </div>
          </div>
          <div className="col-md-3 col-xs-6">
            <div className="form-group">
              <label>Empresas</label>
              <Select placeholder="Seleccione una empresa" name="empresa" options={empresas}
                onChange={e => { setEmpresa(e.key) }} />
            </div>
          </div>
          <div className="col-md-3 col-xs-6">
            <div className="form-group">
              <label>Viajes</label>
              <Select placeholder="Seleccione una opcion" options={filtro}
                onChange={e => { setViaje(e.value) }} />
            </div>
          </div>
          <div className="col-md-1">
          </div>
          <div className="col-lg-6 col-sm-6 col-md-6">
            <ExcelFile filename={name} element={<button style={{ marginLeft: 10 }} filename="Reporte 1" className="btn btn-success">Exportar Excel</button>}>
              <ExcelSheet data={programacionData} name="Operacion">
                <ExcelColumn label="Viaje" value="tipoViaje" />
                <ExcelColumn label="Estado" value="estado" />
                <ExcelColumn label="Fecha" value="fecha" />
                <ExcelColumn label="Centro de Costos" value="centroCosto" />
                <ExcelColumn label="Hora Inicio Itinerada" value="horaInicioItinerada" />
                <ExcelColumn label="Hora Inicio Real" value="horaInicioReal" />
                <ExcelColumn label="Cumplimiento de Servicio Proveedor" value="servicio" />
                <ExcelColumn label="Tipo de Trayecto" value="tipoTrayecto" />
                <ExcelColumn label="No. Equipo" value="equipo" />
                <ExcelColumn label="Conductor" value="conductor" />
                <ExcelColumn label="Pasajeros Programados" value="pasajerosProgramados" />
                <ExcelColumn label="Pasajeros Abordados" value="pasajerosAbordados" />
                <ExcelColumn label="Ruta (Por Trayecto)" value="ruta" />
                <ExcelColumn label="Area usuaria" value="areaUsuaria" />
                <ExcelColumn label="Flota (Aeronave)" value="flota" />
                <ExcelColumn label="Tipo de Entrenamiento" value="entrenamiento" />
                <ExcelColumn label="Hora Llegada Itinerada" value="horaLlegadaItinerada" />
                <ExcelColumn label="Hora Llegada Real" value="horaLlegadaReal" />
                <ExcelColumn label="DifF" value="diff" />
                <ExcelColumn label="KM Inicial" value="kmInicial" />
                <ExcelColumn label="KM Final" value="kmFinal" />
                <ExcelColumn label="KM Dif" value="difKm" />
                <ExcelColumn label="Tiempo Real Recorrido" value="tiempoRealRecorrido" />
                <ExcelColumn label="Zona" value="zona" />
                <ExcelColumn label="Costo del Trayecto" value="costo" />
                <ExcelColumn label="Carretera" value="carretera" />
                <ExcelColumn label="Velocidad Promedio (KM)" value="velocidadPromedio" />
                <ExcelColumn label="Velocidad Maxima (KM)" value="velocidadMaxima" />
                <ExcelColumn label="Observaciones" value="comentarioFinal" />
                <ExcelColumn label="App Conductor" value="vConductor" />
                <ExcelColumn label="App Scanner" value="vScanner" />
              </ExcelSheet>
              <ExcelSheet data={programacion.reporte} name="Detalle de Reporte">
                <ExcelColumn label="Viaje" value="tipoViaje" />
                <ExcelColumn label="Fecha" value="fecha" />
                <ExcelColumn label="Nombre" value="nombre" />
                <ExcelColumn label="Centro de costos" value="centroCostoPasajero" />
                <ExcelColumn label="Codigo Empleado" value="numeroEmpleado" />
                <ExcelColumn label="Area Usuaria" value="areaUsuariaPasajero" />
                <ExcelColumn label="Toque Timbre" value="toqueTimbre" />
                <ExcelColumn label="Hora Subida" value="horaSubida" />
                <ExcelColumn label="Dif" value="horaDiff" />
                <ExcelColumn label="Abordo" value="abordo" />
                <ExcelColumn label="Georeferencia" value="coordenadas" />
              </ExcelSheet>
            </ExcelFile>
          </div>
        </div>
        <br />
        <br />
        <div className="row">
          <div className="col-12">
            <ul className="nav nav-tabs m-bottom flex-column flex-md-row justify-content-end" role="tablist">
              <li className="nav-item">
                <a className="nav-link active show" id="operacional-tab" data-toggle="tab" href="#operacional" role="tab"
                  aria-controls="operacional" aria-selected="true"><i className="fa fa-book"></i>&nbsp;&nbsp;&nbsp;Reporte Operacional</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" id="detalle-tab" data-toggle="tab" href="#detalle" role="tab" aria-controls="detalle"
                  aria-selected="false"><i className="fa fa-book"></i>&nbsp;&nbsp;&nbsp;Detalle de Reportes</a>
              </li>
            </ul>
          </div>
        </div>

      </div>
      <h1>Reporte Operacional</h1>
      
      {programacion.isLoading
      ? <div style={{ marginTop: 20 }}><Pulse /></div>
      :<div className="tab-content" id="myTabContent">
        <div className="tab-pane fade active show" id="operacional" role="tabpanel" aria-labelledby="operacional-tab">
          <BootstrapTable data={programacionData}
            pagination={true}
            search={true}
            hover
			options={{onRowClick:modalObser}}
          >
            <TableHeaderColumn width={'150'} dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='tipoViaje' dataAlign='center' dataSort={true} >Tipo Viaje</TableHeaderColumn>
            <TableHeaderColumn width={'130'} dataField='estado' dataAlign='center' dataSort={true} >Estado</TableHeaderColumn>
            <TableHeaderColumn width={'130'} dataField='fecha' dataAlign='center' dataSort={true} >Fecha</TableHeaderColumn>
            <TableHeaderColumn width={'180'} dataField='centroCosto' dataAlign='center' dataSort={true} >Centro de Costos</TableHeaderColumn>
            <TableHeaderColumn width={'180'} dataField='horaInicioItinerada' dataAlign='center' dataSort={true} >Hora Inicio Itinerada</TableHeaderColumn>
            <TableHeaderColumn width={'180'} dataField='horaInicioReal' dataAlign='center' dataSort={true} >Hora Inicio Real</TableHeaderColumn>
            <TableHeaderColumn width={'240'} dataField='servicio' dataAlign='center' dataSort={true} >Cumplimiento de Servicio de Proveedor</TableHeaderColumn>
            <TableHeaderColumn width={'180'} dataField='tipoTrayecto' dataAlign='center' dataSort={true} >Tipo de Trayecto</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='equipo' dataAlign='center' dataSort={true} >No. Equipo</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='conductor' dataAlign='center' dataSort={true} >Conductor</TableHeaderColumn>
            <TableHeaderColumn width={'330'} dataField='pasajerosProgramados' dataAlign='center' dataSort={true} >Pasajeros Programados</TableHeaderColumn>
            <TableHeaderColumn width={'330'} dataField='pasajerosAbordados' dataAlign='center' dataSort={true} >Pasajeros Abordados</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='ruta' dataAlign='center' dataSort={true} >Ruta (Por Trayecto)</TableHeaderColumn>
            <TableHeaderColumn width={'180'} dataField='areaUsuaria' dataAlign='center' dataSort={true} >Area usuaria</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='flota' dataAlign='center' dataSort={true} >Flota</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='entrenamiento' dataAlign='center' dataSort={true} >Tipo de Entrenamiento</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='horaLlegadaItinerada' dataAlign='center' dataSort={true} >Hora llegada Itinerada</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='horaLlegadaReal' dataAlign='center' dataSort={true} >Hora llegada real</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='diff' dataAlign='center' dataSort={true} >Diff</TableHeaderColumn>
            <TableHeaderColumn width={'180'} dataField='kmInicial' dataAlign='center' dataSort={true} >KM Inicial</TableHeaderColumn>
            <TableHeaderColumn width={'180'} dataField='kmFinal' dataAlign='center' dataSort={true} >KM Final</TableHeaderColumn>
            <TableHeaderColumn width={'180'} dataField='difKm' dataAlign='center' dataSort={true} >Dif KM</TableHeaderColumn>
            <TableHeaderColumn width={'200'} dataField='tiempoRealRecorrido' dataAlign='center' dataSort={true} >Tiempo Real Recorrido</TableHeaderColumn>
            <TableHeaderColumn width={'350'} dataField='zona' dataAlign='center' dataSort={true} >Zona</TableHeaderColumn>
            <TableHeaderColumn width={'180'} dataField='costo' dataAlign='center' dataSort={true} >Costo del Trayecto</TableHeaderColumn>
            <TableHeaderColumn width={'180'} dataField='carretera' dataAlign='center' dataSort={true} >Carretera</TableHeaderColumn>
            <TableHeaderColumn width={'180'} dataField='velocidadPromedio' dataAlign='center' dataSort={true} >Velocidad Promedio (KM)</TableHeaderColumn>
            <TableHeaderColumn width={'180'} dataField='velocidadMaxima' dataAlign='center' dataSort={true} >Velocidad Maxima (KM)</TableHeaderColumn>
            <TableHeaderColumn width={'300'} dataField='comentarioFinal' dataAlign='center' dataSort={true} >Observaciones</TableHeaderColumn>
            <TableHeaderColumn width={'180'} dataField='vConductor' dataAlign='center' dataSort={true} >App Conductor</TableHeaderColumn>
            <TableHeaderColumn width={'180'} dataField='vScanner' dataAlign='center' dataSort={true} >App Scanner</TableHeaderColumn>
          </BootstrapTable>
        </div>
        <div className="tab-pane fade" id="detalle" role="tabpanel" aria-labelledby="detalle-tab">
          <BootstrapTable data={programacion.reporte}
            pagination={true}
            search={true}
            hover 
			>
            <TableHeaderColumn width={'150'} dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='tipoViaje' dataAlign='center' dataSort={true} >Viaje</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='fecha' dataAlign='center' dataSort={true} >Fecha</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='nombre' dataAlign='center' dataSort={true} >Nombre</TableHeaderColumn>
            <TableHeaderColumn width={'150'} dataField='centroCostoPasajero' dataAlign='center' dataSort={true} >Centro de costo</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='numeroEmpleado' dataAlign='center' dataSort={true} >Codigo empleado</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='areaUsuariaPasajero' dataAlign='center' dataSort={true} >Area Usuaria</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='toqueTimbre' dataAlign='center' dataSort={true} >Toque Timbre</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='horaSubida' dataAlign='center' dataSort={true} >Hora Subida</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='horaDiff' dataAlign='center' dataSort={true} >Dif</TableHeaderColumn>
            <TableHeaderColumn width={'230'} dataField='pasajeroSubio' dataAlign='center' dataSort={true} >Abordo</TableHeaderColumn>
            <TableHeaderColumn width={'280'} dataField='coordenadas' dataAlign='center' dataSort={true} >Georeferencia</TableHeaderColumn>
          </BootstrapTable>
        </div>
      </div>
      } 

      <br></br>
      <footer className="footer-pg mt-auto py-3" style={{ width: '100%' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-sm-4">
            </div>
            <div className="col-sm">
              <img src={copyright} />
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

const mapStateToProps = (state) => ({
  EmpresaUID: state.nodo_empresa
});

export default connect(mapStateToProps, null)(ReporteOperacionalA);


// WEBPACK FOOTER //
// ./src/Components/Reportes/ReporteOperacionalA.js